import { Box } from "@mui/material";
import { useState } from "react";
import { getOptimizedImageUrl } from "@/components/_helpers";
import useCoverTint from "@/hooks/useCoverTint";
import NowPlayingBars from "./NowPlayingBars";
import VinylCover from "./VinylCover";

interface FeaturedReleaseArtProps {
  imageUrl?: string;
  fallbackImageUrl?: string;
  alt: string;
  playing?: boolean;
  sharedKey?: string;
}

const WIDTHS = [320, 480, 640, 800];

export function FeaturedReleaseArt({ imageUrl, fallbackImageUrl, alt, playing = false, sharedKey }: FeaturedReleaseArtProps) {
  const [ready, setReady] = useState(false);
  const tint = useCoverTint(imageUrl, ready);
  const source = imageUrl || fallbackImageUrl || "";
  const src = getOptimizedImageUrl(source, { width: 560, quality: 85 });
  const srcSet = src !== source ? WIDTHS.map((width) => `${getOptimizedImageUrl(source, { width, quality: 85 })} ${width}w`).join(", ") : undefined;
  const glow = source ? getOptimizedImageUrl(source, { width: 64, quality: 50 }) : "";

  return (
    <Box sx={{ position: "relative", width: "100%", isolation: "isolate" }}>
      {glow ? (
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            inset: "-10% -6% -14% -10%",
            zIndex: -1,
            backgroundImage: `url(${glow})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(42px) saturate(1.5)",
            opacity: tint ? 0.55 : 0.4,
            borderRadius: "40%",
            transform: "translateZ(0)",
            pointerEvents: "none",
          }}
        />
      ) : null}
      <VinylCover
        src={src}
        srcSet={srcSet}
        sizes="(min-width: 900px) 320px, 86vw"
        alt={alt}
        playing={playing}
        peek="always"
        tint={tint}
        radius="10px"
        shift="22%"
        priority
        sharedKey={sharedKey}
        onImageLoad={() => setReady(true)}
      />
      {playing ? (
        <Box
          sx={{
            position: "absolute",
            left: "10px",
            bottom: "10px",
            zIndex: 2,
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            px: "10px",
            minHeight: "26px",
            borderRadius: "999px",
            backgroundColor: "rgba(8,8,8,0.72)",
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            fontSize: "12px",
            fontWeight: 700,
          }}
        >
          <NowPlayingBars playing size={12} color="currentColor" />
          Now playing
        </Box>
      ) : null}
    </Box>
  );
}

export default FeaturedReleaseArt;
